import React from "react";
import { BaseDateValidationMessage, DateMonth, DateYear, SelectBoxLabel } from "../date";
import { DateInputWrapper } from "../date/dateInputWrapper";
import Wrapper from "../date/date.styles";
import { useFormikContext } from "formik";
import { useSetDefaultValue } from "@hooks/index";
import { MarginLeftRow, PaddingLeftCol } from "@components/leftGrid";
import { useSelector } from "react-redux";

const ariaLabel = "employment start";

export const DateStarted = () => {
  const {
    values: {
      dateStarted
    },
    errors,
    touched,
    handleChange,
    handleBlur
  } = useFormikContext();
  const { month, year } = dateStarted || {}
  const name = "dateStarted";
  const { employmentMonth, employmentYear } = useSelector(s => s.StartUp.queryString);

  useSetDefaultValue(name, {
    day: "1",
    month: employmentMonth || "",
    year: employmentYear || "",
  });
  
  return (
    <Wrapper>
      <MarginLeftRow>
        <PaddingLeftCol xl={12}>
          <div className="selectBox">
            <SelectBoxLabel tooltip="What date did you start with your employer, month and year are required." name={name}>
              Date started
            </SelectBoxLabel>
            <MarginLeftRow className={`selectBox-Input`}>
              <DateInputWrapper xs={12}>
                <DateMonth
                  ariaLabel={ariaLabel}
                  name={name}
                  month={month}
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                />
                <DateYear
                  ariaLabel={ariaLabel}
                  name={name}
                  year={year}
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  minYear={0}
                  maxYear={-70}
                />
              </DateInputWrapper>
            </MarginLeftRow>
            <BaseDateValidationMessage name={name} errors={errors} touched={touched} />
          </div>
        </PaddingLeftCol>
      </MarginLeftRow>
    </Wrapper>
  );
};

export default DateStarted;